export var routerLink = {
    top: function () { return '/'; },
    areaguide: function (query) { return (query ? '/areaguide/?' + query : '/areaguide/'); },
    faq: function () { return '/faq/'; },
    notes: function () { return '/notes/'; },
    content: function () { return '/content/'; }
};
export default (function (_, inject) { return inject('link', routerLink); });
